import { Controller } from 'stimulus';

export default class extends Controller {

  static targets = ['mdpRow', "selection"]

  handleSelect() {
    const selection = event.target.value;
    if (selection === "" || selection === 'all') {
      this.resetFilter();
    } else {
      this.filterActivites(selection);
    }
  }

  resetFilter() {
    this.mdpRowTargets.forEach(activite => {
      activite.classList.remove('d-none');
    })
  }

  filterActivites(selection) {
    this.mdpRowTargets.forEach(activite => {
      const mdpGenerique = activite.dataset.generique;
      const mdpActivite = activite.dataset.activiteId;
      console.log(activite.dataset.activiteId);
      if (mdpGenerique === selection || mdpActivite === selection) {
        activite.classList.remove('d-none');
      } else {
        activite.classList.add('d-none');
      }
    })
  }
}
